import { Error as ErrorIcon } from '@mui/icons-material'
import { I18n } from 'common'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useSearchStore } from '../../../../../src/store/search/SearchStore'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import { defaultTheme } from 'src/theme'
import { Button } from 'src/ui-components'
import styled from 'styled-components'

const InquiryTimeoutError = observer((): ReactElement => {
  const { setShowContactDrawer } = useUiStateStore()
  const { restoreSearchState } = useSearchStore()
  return (
    <Container>
      <StyledErrorIcon />
      <TitleText>
        <I18n name="oopsSomethingWentWrong" />
      </TitleText>
      <DescriptionText>
        <I18n name="weWereUnableToProcessYourRequest" />
      </DescriptionText>

      <ButtonsContainer>
        <Button
          text="contactUs"
          onClick={() => setShowContactDrawer(true)}
          variant="secondary"
        />
        <Button
          text="tryAgain"
          onClick={() => restoreSearchState()}
          variant="primary"
        />
      </ButtonsContainer>
    </Container>
  )
})

export default InquiryTimeoutError

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 600px;
  background-color: ${defaultTheme.colors.white};
`

const TitleText = styled.span`
  font-family: Oswald, serif;
  font-weight: bold;
  font-size: 28px;
  line-height: 48px;
  color: ${defaultTheme.colors.black};
  margin-bottom: 10px;
  text-transform: uppercase;
`

const DescriptionText = styled.span`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  color: ${defaultTheme.colors.almostBlack};
  padding-bottom: 10px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: auto;
`
const StyledErrorIcon = styled(ErrorIcon)`
  width: 60px;
  height: 60px;
  color: ${defaultTheme.colors.red};
`
